import {ID} from '~/lib/model';

export const sourcesLinks = {
    sources: () => '/sources',
    source: (sourceId: ID) => `/sources/${sourceId}`
};
